// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"0299040d","453":"1cfc6aac","934":"79fd40a6"}[chunkId] + ".chunk.js";
};